import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

/**
 * Layout for the Account Overview Notes section: the Sales + CSM summaries side by side (a
 * `pair` of equal `col`s that stacks on narrow widths), with the latest CSM note spanning below,
 * mirroring the legacy overview. All tokens come from `THEME`.
 */
export const accountNotesSectionStyles = StyleSheet.create({
	stack: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	pair: {
		display: 'flex',
		gap: THEME.spacing.md,
		alignItems: 'stretch',
		[THEME.queries.sm]: {
			flexDirection: 'column',
		},
	},
	col: {
		flex: 1,
		minWidth: 0,
	},
});
